import React from 'react'
import { addLoginInput } from 'store/login/actions';
import { connect } from "react-redux";

const mapDispatchToProps = {
    addLoginInput
}

const DisplayButton = (props) => (<button onClick={() => props.addLoginInput(props.number)} className="col-4 number-button text-white text-center">{props.number}</button>)

export default connect(undefined, mapDispatchToProps)(DisplayButton)